import { useCallback, useState } from 'react';
import {
  fetchQuery,
  GraphQLTaggedNode,
  useQueryLoader,
  UseQueryLoaderLoadQueryOptions,
  useRelayEnvironment,
  VariablesOf,
} from 'utils/graphClient';
import { OperationType } from 'relay-runtime';

export const usePullToRefreshQuery = <T extends OperationType>(
  query: GraphQLTaggedNode,
  variables: VariablesOf<T>,
  options?: UseQueryLoaderLoadQueryOptions | undefined,
) => {
  const environment = useRelayEnvironment();
  const [_queryRef, loadQuery] = useQueryLoader<T>(query);

  const [isRefreshing, setIsRefreshing] = useState(false);

  const refresh = useCallback(() => {
    if (isRefreshing) {
      return;
    }

    setIsRefreshing(true);

    fetchQuery(environment, query, variables).subscribe({
      complete: () => {
        setIsRefreshing(false);

        loadQuery(
          variables,
          options ? options : { fetchPolicy: 'store-or-network' },
        );
      },
      error: () => {
        setIsRefreshing(false);
      },
    });
  }, [variables, query, environment, isRefreshing, loadQuery, options]);

  return {
    isRefreshing,
    refresh,
    queryRef: _queryRef,
  };
};
